import React from "react"
import AddAssigneeAction from "./AddAssigneeAction"

export default () => {
  return (
    <AddAssigneeAction />
  )
}
